module.exports = __webpack_public_path__ + "static/media/marble-tm.0a739d32.svg";